import {useEffect} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useCurrentAuthTokens} from '../../services';
import {hasValidOrRefreshableTokens} from '../../services/auth/functions';

export const ReturnUrlKey = 'returnUrl';

/**
 * If auth tokens are invalid or empty this hook will change the browsers location
 * to the login page. It tries to save the calling page in the querystring for
 * redirection after login again.
 */
export const useAuthNavigation = () => {
  const history = useHistory();
  const location = useLocation();
  const authTokens = useCurrentAuthTokens();
  const query = new URLSearchParams(location.search);
  const returnUrl = query.get(ReturnUrlKey) || location.pathname;

  useEffect(() => {
    if (!hasValidOrRefreshableTokens(authTokens)) {
      history.replace(`/login?returnUrl=${returnUrl}`);
    }
  }, [authTokens, history, location.pathname, returnUrl]);
};
